if(!customElements.get('accordion-group')){
    class AccordionGroup extends HTMLElement {
        constructor() {
            super();
            this.singleOpen = this.getAttribute('data-single-open') === 'true';
            this.accordions = this.querySelectorAll('details.accordion');
        }
        connectedCallback() {
            this.accordions.forEach(accordion => {
                accordion.addEventListener('click',(e) => this.handleAccordionClick(e, accordion));
            });
        }

        handleAccordionClick(e, accordion) {
            e.stopPropagation();
            if(this.singleOpen){
                this.closeAllOtherAccordions(accordion);
            }
        }

        closeAllOtherAccordions(currentAccordion) {
            this.accordions.forEach(accordion => {
                if(accordion !== currentAccordion){
                    accordion.open = false;
                }
            });
        }
    }
    customElements.define('accordion-group', AccordionGroup);
}